module.exports = __webpack_public_path__ + "static/g-CHernandez-c700b53d5dc1f4d7f8c9f896b1ff5bc4.jpg";